import lowerCase from 'lodash/lowerCase';

export function stringIncludes(string: any, segment: any) {
    return lowerCase(string).replace(/ /g, '').includes(lowerCase(segment).replace(/ /g, ''));
}
